document.addEventListener("DOMContentLoaded", function() {
    // Function to show the popup
    function showPopup(message) {
        const popup = document.getElementById('favorites-popup');
        const messageElement = document.getElementById('popup-message');
        messageElement.textContent = message;
        popup.style.display = 'flex'; // Show the popup
    }

    // Function to hide the popup
    function hidePopup() {
        const popup = document.getElementById('favorites-popup');
        popup.style.display = 'none'; // Hide the popup
    }

    // Event listener for the close button
    document.querySelector('.close-popup').addEventListener('click', hidePopup);

    // Function to add a product to favorites
    function addToFavorites(product) {
        const favorites = JSON.parse(localStorage.getItem('favoritesProducts')) || [];
        
        // Log the current favorites
        console.log("Current Favorites:", favorites);

        // Check if the product ID is valid
        if (!product.id) {
            console.error("Product ID is missing.");
            return;
        }

        // Log the product being added
        console.log("Adding Product to Favorites:", product);

        // Check if the product is already in favorites
        if (!favorites.some(item => item.id === product.id)) {
            favorites.push(product);
            localStorage.setItem('favoritesProducts', JSON.stringify(favorites));
            showPopup(`${product.title} has been added to your favorites!`);
        } else {
            showPopup(`${product.title} is already in your favorites.`);
        }
    }

    // Event listener for the "Add to Favorite" badge
    document.querySelectorAll('.badge--add-to-favorite').forEach(badge => {
        badge.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent default anchor behavior

            // Get product data from data attributes
            const product = {
                id: this.getAttribute('data-product-id'),
                title: this.getAttribute('data-product-title'),
                image: this.getAttribute('data-product-image'),
                sku: this.getAttribute('data-product-sku'),
                price: this.getAttribute('data-product-price'),
                inventory: this.getAttribute('data-product-inventory'),
                handle: this.getAttribute('data-product-handle'),
                variantId: this.getAttribute('data-variant-id') // Ensure this attribute exists
            };

            // Log the product data
            console.log("Product Data from Badge:", product);

            // Add product to favorites
            addToFavorites(product);
        });
    });
});